import { Mapper } from '@sdk/sdk';
import { AssistantAuthorization } from '../auth';
import { ApiAssistantAuthorizationMap } from './api-assistant-authorization.map';

const SECONDS_PER_MINUTE = 60;

/**
 * The response only carries the code: the host it belongs to is the one the
 * request went to, so the mapper is built for that host.
 */
export class ApiAssistantAuthorizationMapper
  implements Mapper<AssistantAuthorization, ApiAssistantAuthorizationMap>
{
  constructor(private _instance: string) {}

  fromMap(map: ApiAssistantAuthorizationMap): AssistantAuthorization {
    const expiresInMinutes = Math.ceil(map.expires_in / SECONDS_PER_MINUTE);
    return new AssistantAuthorization({ code: map.code, instance: this._instance, expiresInMinutes });
  }
}
